const data = {
	excursions: [
		{
			id: "123",
			title: "Eco Tour Antigua",
			image:
				"https://assets.sunwingtravelgroup.com/image/upload/f_auto,q_auto/sunwing-prod/ExcursionImages/ANUC01/16x9/001.jpg",
			description:
				"Set off on a breathtaking boat tour along Antigua's picturesque coastline where you'll get a chance to explore the 22 pristine, desert islands of North Sound Antigua!",
			url: "/en",
		},
		{
			id: "456",
			title: "The Excellence Power Catamaran",
			image:
				"https://assets.sunwingtravelgroup.com/image/upload/f_auto,q_auto/sunwing-prod/ExcursionImages/ANUW02/16x9/001.jpg",
			description: "Get ready to take an unforgettable cruise off the coast of Antigua!",
			url: "/en",
		},
		{
			id: "789",
			title: "Mystic Sunset Cruise",
			image:
				"https://assets.sunwingtravelgroup.com/image/upload/f_auto,q_auto/sunwing-prod/ExcursionImages/ANUW04/16x9/001.jpg",
			description:
				"Admire breathtaking views of the sunset over the horizon on board a comfortable catamaran.",
			url: "/en",
		},
		{
			id: "101",
			title: "Cades Reef Sail & Snorkel",
			image:
				"https://assets.sunwingtravelgroup.com/image/upload/f_auto,q_auto/sunwing-prod/ExcursionImages/ANUW01/16x9/001.jpg",
			description:
				"Enjoy a fantastic tour of Antigua's breathtaking natural beauty on board a comfortable catamaran.",
			url: "/en",
		},
	],
	golf: [
		{
			id: "112",
			title: "Cedar Valley Golf Course",
			address: "Cedar Valley, St. John's, Antigua & Barbuda",
			architect: "Ralph Aldridge",
			telephone: "268-462-0161",
			numHoles: 18,
			fairways: "",
			yardage: "6157 | 5884 | 5528",
			rating: "",
			par: 70,
			greens: "",
			spikes: "",
			slope: "124 | 122 | 120",
		},
		{
			id: "131",
			title: "Jolly Harbor Marina & Golf Course",
			address: "Antigua and Barbuda",
			architect: "Karl Litton",
			telephone: "268-462-7771",
			numHoles: 18,
			fairways: "",
			yardage: "5,587",
			rating: "",
			par: 71,
			greens: "",
			spikes: "",
			slope: "",
		},
	],
	spas: [
		{
			id: "415",
			title: "Cocobay Resort Antigua",
			services: ["Massage services ($)", "Facial treatments ($)", "Manicure ($)"],
			link: "/en",
		},
		{
			id: "161",
			title: "Galley Bay Resort and Spa",
			services: ["Spa Services ($)", "Beauty Salon ($)"],
			link: "/en",
		},
		{
			id: "718",
			title: "Hammock Cove Resort and Spa",
			services: ["Spa treatments ($)"],
			link: "/en",
		},
		{
			id: "192",
			title: "Jolly Beach Resort",
			services: ["Spa Services ($)", "Beauty Salon ($)", "Body and facial treatments ($)"],
			link: "/en",
		},
		{
			id: "021",
			title: "Ocean Point Resort and Spa",
			services: ["Spa Services ($)"],
			link: "/en",
		},
		{
			id: "222",
			title: "Pineapple Beach Club",
			services: ["Spa Services ($)"],
			link: "/en",
		},
		{
			id: "324",
			title: "Royalton Antigua Resort and Spa",
			services: ["Spa Services ($)", "Beauty Salon ($)"],
			link: "/en",
		},
		{
			id: "252",
			title: "St James's Club and Villas",
			services: [
				"Spa Services ($)",
				"Beauty Salon ($)",
				"Treatment Rooms ($)",
				"Couples suite ($)",
			],
			link: "/en",
		},
		{
			id: "627",
			title: "Sugar Ridge Resort",
			services: ["Spa Services ($)"],
			link: "/en",
		},
	],
};

export default data;
